import React from 'react';
export function FocusSection() {
  return <section className="w-full bg-white py-24 md:py-40 px-6" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <div className="font-serif italic text-2xl md:text-4xl text-charcoal-500 leading-loose space-y-8" data-id="element-88">
          <p data-id="element-89">La maternidad no es solo aprender qué hacer.</p>
          <p data-id="element-90">También es aprender a escuchar… a observar… a conectar</p>
          <p data-id="element-91">Con tu bebé y con vos misma.</p>
          <p className="text-warm-500 mt-12" data-id="element-92">
            Tu bebé no viene con un manual.
            <br data-id="element-93" />
            Pero eso no significa que tengas que hacerlo sola.
          </p>
        </div>
      </div>
    </section>;
}